import { QueryHookOptions } from '@apollo/client';

import { useKioskAssetQuery, KioskAssetQuery } from '@occc/graphql';

type GetKioskAssetProps = {
  id: string;
  baseOptions?: Omit<QueryHookOptions<KioskAssetQuery, { id: string }>, 'variables'>;
};

export const useGetKioskAsset = ({ id, baseOptions }: GetKioskAssetProps) => {
  const response = useKioskAssetQuery({
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    ...baseOptions,
    variables: { id },
  });

  return {
    ...response,
    asset: response.data?.kioskAsset,
  };
};
